import { NgClass, NgStyle, NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  TemplateRef,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { I18NextModule } from 'angular-i18next';
import { IconComponent } from 'src/app/common/icon/icon.component';
import { AvatarDirective } from '../../../common/avatar/avatar.directive';
import { BasePlusComponent } from '../../components/base/base-plus.component';
import { UserRole } from 'src/types/graphql';
import { SafePipe } from '../../pipes/safe.pipe';

@Component({
  selector: 'sharry-generic-dialog',
  standalone: true,
  imports: [
    MatButtonModule,
    I18NextModule,
    IconComponent,
    AvatarDirective,
    NgClass,
    NgTemplateOutlet,
    NgStyle,
    SafePipe,
  ],
  templateUrl: './generic-dialog.component.html',
  styleUrls: ['./generic-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GenericDialogComponent extends BasePlusComponent implements OnInit {
  @Input() fullscreen = false;
  @Input() header: {
    type: 'full' | 'onlyTitle' | 'user' | 'none' | 'logo';
    title?: string;
    subtitle?: string;
    imgUrl?: string;
  };
  @Input() footerTemplate: TemplateRef<any>;
  @Input() increasedHeight = false;
  @Input() hideCloseIcon = false;
  @Input() hideBackIcon = true;
  @Input() footerType: 'standard' | 'standardGrow' | 'standardWithText' | 'deleteUser' | 'template' | 'none';
  @Input() hideFooterClose?: boolean;
  @Input() hideFooterConfirm?: boolean;
  @Input() hideFooterDelete?: boolean;
  @Input() footerStandardButtonLabel?: string;
  @Input() footerText?: string;
  @Input() disabled = false;
  @Input() userType: { sharrylandPartner: boolean; role: UserRole; noBorder?: boolean } = {
    sharrylandPartner: false,
    role: UserRole.StandardUser,
    noBorder: false,
  };
  @Input() backgroundColor?: string;
  @Input() footerTemplateContext: object;
  @Output() avatarClicked = new EventEmitter();
  @Output() cancel = new EventEmitter();
  @Output() back = new EventEmitter();
  @Output() confirm = new EventEmitter();

  privateFullscreen: boolean;
  private openMode: 'mobile' | 'web';
  @Input() footerAlignStart: boolean = false;

  constructor() {
    super();
  }

  @HostListener('window:resize') resize() {
    if (
      (this.isMobileNotIpad() && this.openMode === 'web') ||
      (!this.isMobileNotIpad() && this.openMode === 'mobile')
    ) {
      this.cancel.emit();
    }
  }

  ngOnInit() {
    this.openMode = this.isMobileNotIpad() ? 'mobile' : 'web';
    this.privateFullscreen = this.fullscreen;
    if (this.isMobileNotIpad()) {
      this.privateFullscreen = true;
    }
  }
}
